import { Grid, MenuItem, Paper, Stack, Tooltip } from '@mui/material';
import { CleaningServices, FileDownload, Search } from '@mui/icons-material';
import { CustomButton, CustomTextField } from '../../../common/components';
import { COMPLETED_PROJECT_TYPE, COUPON_COLLECTION_TYPE, COUPON_DUE_TYPE } from '../constants/notificationsConstants';

export const FiltersBar = ({
  filters,
  setFilters,
  onSearch,
  onReset,
  onExportCsv,
  loading,
  exportLoading = false,
  exportDisabled = false,
}) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      mb: 2,
    }}
  >
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={2}>
        <CustomTextField
          select
          label="Módulo"
          value={filters.target_app_module}
          onChange={(event) => setFilters((prev) => ({ ...prev, target_app_module: event.target.value }))}
          fullWidth
          disabled={loading}
        >
          <MenuItem value="habitat_99">Habitat 99</MenuItem>
        </CustomTextField>
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          select
          label="Estado"
          value={filters.status}
          onChange={(event) => setFilters((prev) => ({ ...prev, status: event.target.value }))}
          fullWidth
          disabled={loading}
        >
          <MenuItem value="all">Todos</MenuItem>
          <MenuItem value="new">Nueva</MenuItem>
          <MenuItem value="read">Leída</MenuItem>
          <MenuItem value="resolved">Resuelta</MenuItem>
          <MenuItem value="suppressed">Suprimida</MenuItem>
          <MenuItem value="failed">Fallida</MenuItem>
        </CustomTextField>
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          select
          label="Tipo"
          value={filters.notification_type}
          onChange={(event) => setFilters((prev) => ({ ...prev, notification_type: event.target.value }))}
          fullWidth
          disabled={loading}
        >
          <MenuItem value="all">Todos</MenuItem>
          <MenuItem value={COMPLETED_PROJECT_TYPE}>Datos operativos</MenuItem>
          <MenuItem value={COUPON_DUE_TYPE}>Vencimientos</MenuItem>
          <MenuItem value={COUPON_COLLECTION_TYPE}>Cobros</MenuItem>
        </CustomTextField>
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          select
          label="Severidad"
          value={filters.severity}
          onChange={(event) => setFilters((prev) => ({ ...prev, severity: event.target.value }))}
          fullWidth
          disabled={loading}
        >
          <MenuItem value="all">Todas</MenuItem>
          <MenuItem value="info">Info</MenuItem>
          <MenuItem value="warning">Warning</MenuItem>
          <MenuItem value="critical">Critical</MenuItem>
        </CustomTextField>
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          select
          label="Urgencia"
          value={filters.is_urgent}
          onChange={(event) => setFilters((prev) => ({ ...prev, is_urgent: event.target.value }))}
          fullWidth
          disabled={loading}
        >
          <MenuItem value="all">Todas</MenuItem>
          <MenuItem value="true">Urgentes</MenuItem>
          <MenuItem value="false">No urgentes</MenuItem>
        </CustomTextField>
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          label="Destinatario"
          value={filters.recipient}
          onChange={(event) => setFilters((prev) => ({ ...prev, recipient: event.target.value }))}
          fullWidth
          disabled={loading}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          label="Desde"
          type="date"
          value={filters.date_from}
          onChange={(event) => setFilters((prev) => ({ ...prev, date_from: event.target.value }))}
          fullWidth
          disabled={loading}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          label="Hasta"
          type="date"
          value={filters.date_to}
          onChange={(event) => setFilters((prev) => ({ ...prev, date_to: event.target.value }))}
          fullWidth
          disabled={loading}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <CustomTextField
          label="Contrato"
          value={filters.contract_number}
          onChange={(event) => setFilters((prev) => ({ ...prev, contract_number: event.target.value }))}
          fullWidth
          disabled={loading}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <CustomTextField
          label="Buscar"
          value={filters.search}
          onChange={(event) => setFilters((prev) => ({ ...prev, search: event.target.value }))}
          fullWidth
          disabled={loading}
        />
      </Grid>
      <Grid item xs={12} md={3} mt={1.5}>
        <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
          <Tooltip title="Buscar">
            <span style={{ display: 'flex', flex: 1 }}>
              <CustomButton
                variant="base"
                buttonIcon={Search}
                onClick={onSearch}
                disabled={loading}
                aria-label="Buscar"
                fullWidth
                sx={{ flex: 1, minWidth: 0 }}
              />
            </span>
          </Tooltip>
          <Tooltip title="Limpiar">
            <span style={{ display: 'flex', flex: 1 }}>
              <CustomButton
                variant="warning"
                buttonIcon={CleaningServices}
                onClick={onReset}
                disabled={loading}
                aria-label="Limpiar"
                fullWidth
                sx={{ flex: 1, minWidth: 0 }}
              />
            </span>
          </Tooltip>
          <Tooltip title="Descargar CSV">
            <span style={{ display: 'flex', flex: 1 }}>
              <CustomButton
                variant="info"
                buttonIcon={FileDownload}
                onClick={onExportCsv}
                disabled={loading || exportDisabled}
                isLoading={exportLoading}
                aria-label="Descargar CSV"
                fullWidth
                sx={{ flex: 1, minWidth: 0 }}
              />
            </span>
          </Tooltip>
        </Stack>
      </Grid>
    </Grid>
  </Paper>
);
